module.exports = __webpack_public_path__ + "img/t-right.ccfc1c0c.png";